import { QUERY_PARAMS } from "constants/constants";

export const extractFilters = (searchParams: URLSearchParams) => {
  const filters: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    if (key.startsWith(`${QUERY_PARAMS.FILTERS}[`)) {
      const keyParts = key.split("[");
      if (keyParts.length > 1 && keyParts[1]) {
        const filterKey = keyParts[1].replace("]", "");
        filters[filterKey] = value;
      }
    }
  });
  return filters;
};
